<template>
<DxGallery :data-source="galleryData" height="100%" />
</template>

<script setup>
import { defineProps } from 'vue';
import { DxGallery } from 'devextreme-vue/gallery';

const props = defineProps([
	'settings',
]);
console.log(props.settings);

const galleryData = [
	'https://js.devexpress.com/Content/images/doc/24_1/PhoneJS/person2.png',
	'https://js.devexpress.com/Content/images/doc/24_1/PhoneJS/person3.png',
	'https://js.devexpress.com/Content/images/doc/24_1/PhoneJS/person4.png',
	'https://js.devexpress.com/Content/images/doc/24_1/PhoneJS/person1.png',
];

</script>